import { TabelaPrecoItem } from "../types/tabela_preco_item";

export const novaTabelaPrecoItem = (): TabelaPrecoItem => {
  return {
    posicao: 0,
    produto: "",
    valor: 0,
  };
};
